import { Component, OnInit } from '@angular/core';
import { ComercioHome } from 'src/app/Models/Comercio/Comercio';
import { BackOfficeSession } from 'src/app/Services/Api.BackOfficeSession/BackOfficeSession';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit {
  
  comercio: ComercioHome;

  constructor(
    private _authenticationService: BackOfficeSession) { }

  ngOnInit() {
    this._authenticationService.obtenerInfoComercio(sessionStorage.getItem('comercioID')).subscribe((res :any) =>{
      if (res.record){
        this.comercio = res.record;
      }
    })
  }

}
